import React, { useState } from 'react';
import { Tabs } from 'antd';
import Layout from '../../components/Layout';
import CustomersList from './CustomersList';
import KYCList from './KYCList';
import AccountsList from './AccountsList';

const CustomerManagement = () => {
  const [activeTab, setActiveTab] = useState('customers');

  const items = [
    {
      key: 'customers',
      label: 'All Customers',
      children: <CustomersList />,
    },
    {
      key: 'kyc',
      label: 'KYC Reports',
      children: <KYCList />,
    },
    {
      key: 'accounts',
      label: 'Accounts Reports',
      children: <AccountsList />,
    }
  ];

  return (
    <Layout>
      <div style={{ padding: '0 24px' }}>
        <h1 style={{ marginBottom: 24, fontSize: '24px', fontWeight: '600' }}>Customer Reports</h1>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={items}
          className="customer-tabs"
          destroyInactiveTabPane
        />
      </div>
    </Layout>
  );
};

export default CustomerManagement;
